<template>
  <HeaderComponent />
  <transition name="fade" mode="out-in">
    <router-view/>
  </transition>
  <FooterComponent />
  <ContactSupportComponent />
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import HeaderComponent from './components/Header/HeaderComponent.vue';
import FooterComponent from "./components/Footer/FooterComponent.vue";
import ContactSupportComponent from "./components/ContactSupport/ContactSupportComponent.vue";

export default {
  components: {
    HeaderComponent ,
    FooterComponent,
    ContactSupportComponent
  }
}
</script>

<style>
/* add amiri font */
@import "./assets/fonts/fonts.css";
body {
  direction: rtl;
  font-family: "globalFont", sans-serif;
  overflow-x: hidden;
  background-color: #f8f8f7;
  position: relative;
  scroll-behavior: smooth;
}
* {
  box-sizing: border-box;
}

.section-title {
  color: #2c3e50;
  padding: 1.2rem 0;
  /* font-weight: bold; */
}
.section-title span {
  color: #FF9D23;
}
@media(max-width:767px) {
  .hidden {
    display: none !important;
  }
}

/* Define your transition styles */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease-in-out;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

/* html::-webkit-scrollbar {
  background-color: #ff707072;
  opacity: 0.5;
  transition: all 0.5s;
  border-radius: 50px;
  scroll-behavior: smooth;
}
html::-webkit-scrollbar:hover {
  background-color: #FF7070;
}
html::-webkit-scrollbar:hover ::-webkit-scrollbar-thumb {
  background-color: #16C47F;
}
html::-webkit-scrollbar-thumb {
  background-color: #16C47F;
  opacity: 0.5;
  border-radius: 50px;
} */
</style>
